<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8201_100828)">
      <path
        d="M6.16699 9.00008H11.8337M16.0837 9.00008C16.0837 12.9121 12.9123 16.0834 9.00033 16.0834C5.08831
         16.0834 1.91699 12.9121 1.91699 9.00008C1.91699 5.08806 5.08831 1.91675 9.00033
          1.91675C12.9123 1.91675 16.0837 5.08806 16.0837 9.00008Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8201_100828">
        <rect
          width="17"
          height="17"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>